import { useEffect } from 'react';
import Icon from '../AppIcon';

interface NavItem {
  label: string;
  anchor: string;
  section: string;
}

interface MobileNavDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileNavDrawer = ({ isOpen, onClose }: MobileNavDrawerProps) => {
  const navItems: NavItem[] = [
    { label: 'Главная', anchor: '#hero', section: 'hero' },
    { label: 'Как работает', anchor: '#how-it-works', section: 'how-it-works' },
    { label: 'Результаты', anchor: '#results', section: 'results' },
    { label: 'Вопросы', anchor: '#faq', section: 'faq' },
  ];

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleEscape);
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  const handleNavClick = (anchor: string) => {
    const element = document.querySelector(anchor);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      onClose();
    }
  };

  const handleCTAClick = () => {
    window.open('https://t.me/Aidating_love7_bot?start=013_res', '_blank');
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-foreground/50 z-drawer-backdrop md:hidden transition-opacity duration-300"
        onClick={onClose}
        aria-hidden="true"
      />
      
      <div
        className={`fixed top-0 right-0 h-full w-[280px] bg-background shadow-2xl z-drawer md:hidden transform transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-4 border-b border-border">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Heart" size={20} color="white" />
              </div>
              <span className="text-lg font-bold text-foreground">AI Dating</span>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-md hover:bg-muted transition-colors duration-200"
              aria-label="Close menu"
            >
              <Icon name="X" size={24} color="var(--color-foreground)" />
            </button>
          </div>

          <nav className="flex-1 overflow-y-auto py-4">
            {navItems.map((item) => (
              <a
                key={item.section}
                href={item.anchor}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.anchor);
                }}
                className="flex items-center gap-3 px-6 py-4 text-base font-medium text-foreground hover:bg-muted transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#pricing"
              onClick={(e) => handleNavClick(e, '#pricing')}
              className="block px-4 py-3 text-foreground hover:bg-muted rounded-md transition-colors"
            >
              Стоимость
            </a>
          </nav>

          <div className="p-4 border-t border-border">
            <a
              href="https://t.me/Aidating_love7_bot?start=010_res"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full px-6 py-3 bg-accent text-accent-foreground text-center font-semibold rounded-lg hover:opacity-90 transition-opacity duration-200"
            >
              пройти тест
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNavDrawer;